import { PublicKey } from '@solana/web3.js'
import { useMemo } from 'react'

import { useSettings } from '@/hooks/use-settings'
import {
  DEFAULT_ORDERBOOK_PROGRAM_ID,
  DEFAULT_ORDERBOOK_SEAT_MANAGER_PROGRAM_ID,
} from '@/utils/helpers'

const useOrderbookIds = () => {
  const { data: settingsData } = useSettings()

  return useMemo(
    () => ({
      programId: new PublicKey(settingsData?.orderbook_program_id || DEFAULT_ORDERBOOK_PROGRAM_ID),
      seatManagerProgramId: new PublicKey(settingsData?.orderbook_seat_manager_program_id || DEFAULT_ORDERBOOK_SEAT_MANAGER_PROGRAM_ID),
    }),
    [
      settingsData?.orderbook_program_id,
      settingsData?.orderbook_seat_manager_program_id,
    ],
  )
}

export default useOrderbookIds
